import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LookupModel } from "../models/Lookups/LookupModel";
import { LookUpItem } from "../models/Lookups/LookupItem";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";

@Injectable({
    providedIn: 'root'
})
export class LookupService {
    ApiUrl = "/api/admin/Lookup/"
    constructor(private http: RequestHandlerService) {
    }

    Loaddropdowns() {
       
        return this.http.get( this.ApiUrl + 'Loaddropdowns');
    }

    AddLookup( AddModel: LookupModel) {
        return this.http.post( this.ApiUrl + 'AddLookup', AddModel);
    }

    EditLookup(EditModel:LookupModel) {
       
        return this.http.post( this.ApiUrl + 'EditLookup', EditModel);
    }


    DeleteLookup( id: number) {
        return this.http.post( this.ApiUrl + 'DeleteLookup', id);
    }


    AddLookupItem( AddModel: LookUpItem) {
      
        return this.http.post( this.ApiUrl + 'AddLookupItem', AddModel);
    }

    EditLookupItem(EditModel:LookUpItem) {
       
        return this.http.post( this.ApiUrl + 'EditLookupItem', EditModel);
    }


    DeleteLookupItem(id: number) {
       
        return this.http.post( this.ApiUrl + 'DeleteLookupItem', id);
    }


    GenerateCodeAll() {
        return this.http.get( this.ApiUrl + 'GenerateCodeAll');
    }

    GenerateApplicationEnums() {
        
        return this.http.get( this.ApiUrl + 'GenerateApplicationEnums');
    }


    GenerateSysNames() {
        return this.http.get( this.ApiUrl + 'GenerateSysNames');
    }

    GenerateCodeById(templateId: number) {
       
        return this.http.post( this.ApiUrl + 'GenerateCodeById', templateId);
    }

}